import Vue from 'vue'

const state = {
  isShowModal: false,
  isShowChkPwd: false,
  isShowPrivacy: false,
  isShowSetting: false,
  isShowProfile: false,
  settting: {
    integralSwitch: 0,
    instructionSwitch: 0
  },
  userInfo: null
}

const getters = {}

const mutations = {
  setEditProfileModalState (state, value) {
    state.isShowProfile = value
  },
  setSettingState (state, value) {
    if (value.type === 1) {
      state.settting.integralSwitch = value.data
    } else if (value.type === 2) {
      state.settting.instructionSwitch = value.data
    } else {
      state.settting = value.data
    }
    Vue._h.storage.local.set('ust', state.settting)
  },
  loadSetting (state, value) {
    let setting = Vue._h.storage.local.get('ust')
    if (!Vue._.isEmpty(setting)) {
      state.settting = setting
    }
  },
  setModalState (state, value) {
    state.isShowModal = value
  },
  setChkPwdModalState (state, value) {
    state.isShowChkPwd = value
  },
  setPrivacyModalState (state, value) {
    state.isShowPrivacy = value
  },
  setSettingModalState (state, value) {
    state.isShowSetting = value
  },
  setUserInfo (state, value) {
    if (Vue._.isEmpty(value)) {
      state.userInfo = null
      Vue._h.storage.local.remove('uinfo')
      Vue._h.storage.local.remove('ust')
    } else {
      state.userInfo = value
      Vue._h.storage.local.set('uinfo', value)
    }
  },
  loadUserInfo (state, value) {
    let u = Vue._h.storage.local.get('uinfo')
    if (!Vue._.isEmpty(u)) {
      state.userInfo = u
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js